import { AppState } from '../meta-reducer/index';
import { select, Store } from '@ngrx/store';
import { filter, map, mergeMap, withLatestFrom, catchError } from 'rxjs/operators';
import { Injectable } from "@angular/core"
import { Actions, ofType, createEffect } from '@ngrx/effects';
import * as UsageInsightActions from './usage.insights.actions';
import { isOverTimeLoadedSelector, selectIsStarsLoadedSelector, selectIsTagLoadedSelector } from './usage.insights.selectors';
import { of } from 'rxjs';
import { RecognitionApiService } from '../../providers/api.service/recognition.api.service';

@Injectable()
export class UsageInsightsffects {

    constructor(private actions$: Actions, private _recognitionApiService: RecognitionApiService, private store: Store<AppState>) { }

    
    loadOverTime$ = createEffect(() => this.actions$
        .pipe(
            ofType(UsageInsightActions.overTimeRequested),
            withLatestFrom(this.store.pipe(select(isOverTimeLoadedSelector))),
            filter(([action, isLoaded]) => !isLoaded),
            mergeMap(action => this._recognitionApiService.getRecognitionOverTime().pipe(
                catchError(error => {
                    this.store.dispatch(UsageInsightActions.overTimeLoadError({ errorMessage: error.message }));
                    return of({
                        data: []
                    });
                })
            )),
            map((result) => {
                return UsageInsightActions.overTimeLoaded({ data: result.data })
            })
        ))

    
    loadStars$ = createEffect(() => this.actions$
        .pipe(
            ofType(UsageInsightActions.starsRequested),
            withLatestFrom(this.store.pipe(select(selectIsStarsLoadedSelector))),
            filter(([action, isLoaded]) => !isLoaded),
            mergeMap(action => this._recognitionApiService.getRecognitionTopStarRewardLeader()
                .pipe(
                    catchError(error => {
                        this.store.dispatch(UsageInsightActions.starsLoadError({ errorMessage: error.message }))
                        return of({
                            receivers: [],
                            senders: []
                        });
                    })
                )),
            map((result) => {
                return UsageInsightActions.starsLoaded(result)
            })
        ))

    
    loadInsightTags$ = createEffect(() => this.actions$
        .pipe(
            ofType(UsageInsightActions.tagRequested),
            withLatestFrom(this.store.pipe(select(selectIsTagLoadedSelector))),
            filter(([action, isLoaded]) => (!isLoaded)),
            mergeMap(action => this._recognitionApiService.getRecognitionUsageDataTags(action['queryParam'])
                .pipe(
                    catchError(error => {
                        this.store.dispatch(UsageInsightActions.tagLoadError({ errorMessage: error.message }))
                        return of({
                            data : []
                        });
                    })
                )),
            map((result) => {
                return UsageInsightActions.tagLoaded({ data: result.data })
            })
        ))

    
    InsightUpdateTags$ = createEffect(() => this.actions$
        .pipe(
            ofType(UsageInsightActions.tagUpdateRequested),
            mergeMap(action => {
                return this._recognitionApiService.getRecognitionUsageDataTags(action['queryParam'])
            }),
            map((result) => {
                return UsageInsightActions.tagUpdated({ data: result.data })
            })
        ))
}
